const labels = {
  "Hong Kong SAR, China": "Hong Kong, China",
  "St. Vincent and the Grenadines": "St. Vincent and G...",
  "Bosnia and Herzegovina": "Bosnia and Herz...",
}

export default function getShortCountryLabel(country) {
  return labels[country] ? labels[country] : country
}
